import type {Idioma} from '@cnc/contracts';
import {useQueryClient} from '@tanstack/react-query';
import {Fragment, useCallback, useMemo, useState, type ReactNode} from 'react';
import {ContextoIdioma} from './contexto-idioma';
import {fijarIdiomaActual, idiomaActual} from './idioma';

// Al cambiar de idioma se vuelve a montar toda la aplicacion (la direccion y
// los filtros se conservan) y se piden de nuevo los datos del servidor, que
// trae mensajes y etiquetas en el idioma nuevo.
export function ProveedorDeIdioma({children}: {children: ReactNode}) {
  const [idioma, setIdioma] = useState<Idioma>(() => {
    fijarIdiomaActual(idiomaActual());
    return idiomaActual();
  });
  const cliente = useQueryClient();

  const cambiar = useCallback(
    (nuevo: Idioma) => {
      if (nuevo === idiomaActual()) return;
      fijarIdiomaActual(nuevo);
      setIdioma(nuevo);
      void cliente.invalidateQueries();
    },
    [cliente],
  );

  const valor = useMemo(() => ({idioma, cambiar}), [idioma, cambiar]);
  return (
    <ContextoIdioma.Provider value={valor}>
      <Fragment key={idioma}>{children}</Fragment>
    </ContextoIdioma.Provider>
  );
}
